export default {
  name: { presence: { allowEmpty: false } },
  content: function(value, attrs) {
    if (attrs.articleType !== 'PDF' && !value) {
      return {
        presence: { allowEmpty: false, message: '^Content cannot be empty' }
      };
    }
    return true;
  },
  parent: {
    presence: { allowEmpty: false, message: '^Collection cannot be empty' }
  },
  visibility: {
    presence: { allowEmpty: false }
  }
};
